"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  return {
    computed: {
      Columns: function Columns() {
        return this.columns;
      }
    }
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2/compiled/state/normal.js
// module id = 661
// module chunks = 1